import { Block, BlockProps } from '@aloft/toolkit-sui';

import { useEffect, useState } from 'react';

import { LoadingScreenSam } from './LoadingScreenSam.tsx';
import { LongLoaderProps, ShortLoaderProps } from './types.ts';

export const LoadingScreenSamFull = ({
  isLoading,
  wrapperProps,
  shortLoaderProps,
  ...props
}: {
  what?: string;
  overrideText?: string;
  isLoading: boolean;
  logoSrc?: string;
  logoWidth?: string;
  animationClassName?: string;
  wrapperProps?: BlockProps;
  longLoaderProps?: LongLoaderProps;
  shortLoaderProps?: ShortLoaderProps;
  lightText?: boolean;
}) => {
  const [isDelayed, setIsDelayed] = useState(Boolean(shortLoaderProps?.delayDurationSeconds));
  useEffect(() => {
    if (isDelayed) {
      setTimeout(
        () => setIsDelayed(false),
        (shortLoaderProps?.delayDurationSeconds ?? 0.001) * 1000,
      );
    }
  });

  return isLoading && !isDelayed ? (
    <Block
      key="global-loader"
      height="100%"
      width="100%"
      position="fixed"
      top={0}
      left={0}
      bottom={0}
      right={0}
      zIndex={1201}
      {...wrapperProps}
    >
      <LoadingScreenSam {...props} fadeIn />
    </Block>
  ) : null;
};
